export default {
  mounted() {
    bus.$on('resizeCanvasDown', this.resizeCanvasDown)
    bus.$on('resizeCanvasUp', this.resizeCanvasUp)
  },
  data(){
    return {
      currentZoom : 1,
      defaultWidth : null,
      defaultHeight : null,
    }
  },
  methods:{
    setDefault(){
      if(!this.defaultWidth){
        this.defaultWidth =  this.canvas.get('width')
        this.defaultHeight =  this.canvas.get('height')
      }
    },
    resizeCanvasDown(){
      this.setDefault()
      let zoom = this.canvas.getZoom();
      zoom -= 0.05;
      this.setZoom(zoom);
    },
    resizeCanvasUp(){
      this.setDefault()
      let zoom = this.canvas.getZoom();
      zoom += 0.05;
      this.setZoom(zoom);
    },
    setZoom(zoom){
      this.setDefault()
      this.currentZoom = zoom;
      this.canvas.setZoom(zoom);
      this.canvas.setWidth(this.defaultWidth * zoom)
      this.canvas.setHeight( this.defaultHeight * zoom)
    }
  }
}
